import { asyncDelay } from "../../../util/Util";
import { CurrencyOption, ProductCategory, ProductCandidateBrief, ShoppingProductDetail, NutritionistInfo, 
         NutritionistClient, NutritionistHealthAdvice, ClientHealthAdvice, ShoppingCartRecord, 
         WeightOption, 
         CountryOption,
         ShoppingAddressSpec,
         BillingAddress,
         ShoppingPickupAddress,
         ShoppingOrder,
         PaymentMethodOption,
         ShoppingOrderBreif,
         ShoppingOrderStatus,
         PaymentMethod,
         HealthAdviceStatus,
         ShippingAddress} from "../ajax-data-types";

import licenceImage from './nutritionist-licence.jpg';
import degreeImage from './sample-bachelor-degree.png';

import sampleFrontImage from './sample-chinese-resident-card-front.png';
import sampleBackImage from './sample-chinese-resident-card-back.png';

export const SampleProductCategories: ProductCategory[]  = [
    {
        name:'新品上市', label:'新品上市'
    },
    {
        name:'功效制剂', label:'功效制剂'
    },
    {
        name:'健康检测', label:'健康检测'
    },
    {
        name:'功能食品', label:'功能食品',
        children:[
            {name:"运动营养", label:"运动营养"},
            {name:"食物补充", label:"食物补充"},
            {name:"特需代餐", label:"特需代餐"},
        ]
    },
    {
        name:'专业推荐', label:'专业推荐',
        children:[
            {name:"母婴专用", label:"母婴专用"},
            {name:"通用产品", label:"通用产品"},
            {name:"循环系统", label:"循环系统"},
            {name:"免疫系统", label:"免疫系统"},
            {name:"消化系統", label:"消化系統"},
            {name:"运动系统", label:"运动系统"},
            {name:"神经系统", label:"神经系统"},
            {name:"内分泌系统", label:"内分泌系统"},
        ]
    },
]

export function generateSampleShoppingProductBriefList():ProductCandidateBrief[]{
    let list:ProductCandidateBrief[] = [];

    for(let i=0; i<50; i++){
       list.push({
           thumbImage:'https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/MET108-021-0017.png?time=1625972105101',
           productCode:'MET108-021-0017',
           productName:'MET  西隆尼片 120',
           price:45.98,
           currencyCode:'CAD',
           count: 1,
           originalPrice: 50.89,
           productType: 'chanpin',
       });
       list.push({
            thumbImage:'https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/CAP106-021-0001_0.png?time=1625972105101',
            productCode:'CAP106-021-0001',
            productName:'CAP 力波胶囊  60',
            price:55.78,
            currencyCode:'CAD',
            count: 1,
            productType: 'chanpin',
        })
    }

    return list;
}


const zh_CN_CurrencyOptions:CurrencyOption[] = [
    {code:'CNY', symbol:'￥', label:'人民币'},
    {code:'CAD', symbol:'$', label:'加元'},
    {code:'USD', symbol:'$', label:'美元'},
    {code:'HKD', symbol:'$', label:'港币'},
    {code:'TWD', symbol:'$', label:'新台币'},
    {code:'UNIS', symbol:'U', label:'U点'},
];

const en_CurrencyOptions:CurrencyOption[] = [
    {code:'CNY', symbol:'￥', label:'Renminbi'},
    {code:'CAD', symbol:'$', label:'Canada Dollar'},
    {code:'USD', symbol:'$', label:'US Dollar'},
    {code:'HKD', symbol:'$', label:'Hongkong Dollar'},
    {code:'TWD', symbol:'$', label:'Taiwen Dollar'},
    {code:'UNIS', symbol:'U', label:'UNIS Point'},
]

export const dflt_currencyOptionsMap:{[key:string]:CurrencyOption[]} = {
    "zh-CN": zh_CN_CurrencyOptions,
    "en": en_CurrencyOptions
}

const zh_CN_paymentMethodOptions:PaymentMethodOption[] = [
    {code:'AliPay', label:'支付宝'},
    {code:'WechatPay', label:'微信支付'},
    {code:'CreditCard', label:'信用卡'},
    {code:'Wallet', label:'U点支付'},
]
const en_paymentMethodOptions:PaymentMethodOption[] = [
    {code:'AliPay', label:'Ali Pay'},
    {code:'WechatPay', label:'Wechat Pay'},
    {code:'CreditCard', label:'Credit Card'},
    {code:'Wallet', label:'UNIS Pay'},
]
export const dflt_paymentMethodOptionsMap:{[key:string]:PaymentMethodOption[]} = {
    "zh-CN": zh_CN_paymentMethodOptions,
    "en": en_paymentMethodOptions
}

const zh_CN_WeightOptions: WeightOption[] = [
    {code:'g', label:'克'},
    {code:'kg', label:'公斤'},
    {code:'p', label:'磅'},
];
const en_WeightOptions: WeightOption[] = [
    {code:'g', label:'gram'},
    {code:'kg', label:'kg'},
    {code:'p', label:'pound'},
];

export const dflt_weightOptionsMap:{[key:string]:WeightOption[]} = {
    'en': en_WeightOptions,
    'zh-CN':zh_CN_WeightOptions
}


const zh_CN_CountryOptions: CountryOption[] = [
    {code: 'CHN', label:'中国大陆 P.R. China'},
    {code: 'CAN', label:'加拿大 Canada'},
    {code: 'HKG', label:'香港(Hong Kong, 中国)'},
    {code: 'MAC', label:'澳门(Macau, 中国)'},
    {code: 'TWN', label:'台湾(Taiwan, 中国)'},
];
const en_CountryOptions: CountryOption[] = [
    {code: 'CHN', label:'China(mainland)'},
    {code: 'CAN', label:'Canada'},
    {code: 'HKG', label:'Hongkong(China)'},
    {code: 'MAC', label:'Macau(China)'},
    {code: 'TWN', label:'Taiwan(China)'},
];
export const dflt_countryOptionsMap:{[key:string]:CountryOption[]} = {
    'en': en_CountryOptions,
    'zh-CN':zh_CN_CountryOptions
}


const zh_CN_ShoppingAddressSpecMap: {[key:string]:ShoppingAddressSpec} = {
    CHN: {
        name: {label: '姓名', isMandatory: true},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'国家/地区', isMandatory: true},
        institution: {label: '公司/机构'},
        postalCode: {label: '邮政编码', isMandatory: true},

        address1: {label: '地址1', isMandatory: true},
        address2: {label: '地址2'},
        address3: {label: '市/区', isMandatory: true},
        address4: {label: '省/直辖市', isMandatory: true,
            options:[
                {key:'安徽', label:'安徽'},
                {key:'北京', label:'北京'},
                {key:'重庆', label:'重庆'},
                {key:'福建', label:'福建'},
                {key:'广东', label:'广东'},
                {key:'甘肃', label:'甘肃'},
                {key:'广西', label:'广西'},
                {key:'贵州', label:'贵州'},
                {key:'河南', label:'河南'},
                {key:'湖北', label:'湖北'},
                {key:'河北', label:'河北'},
                {key:'海南', label:'海南'},
                {key:'黑龙江', label:'黑龙江'},
                {key:'湖南', label:'湖南'},
                {key:'吉林', label:'吉林'},
                {key:'江苏', label:'江苏'},
                {key:'江西', label:'江西'},
                {key:'辽宁', label:'辽宁'},
                {key:'内蒙古', label:'内蒙古'},
                {key:'宁夏', label:'宁夏'},
                {key:'青海', label:'青海'},
                {key:'四川', label:'四川'},
                {key:'山东', label:'山东'},
                {key:'上海', label:'上海'},
                {key:'陕西', label:'陕西'},
                {key:'山西', label:'山西'},
                {key:'天津', label:'天津'},
                {key:'新疆', label:'新疆'},
                {key:'西藏', label:'西藏'},
                {key:'云南', label:'云南'},
                {key:'浙江', label:'浙江'},
            ]
        },

        IDFrontImage: {label: '身份证正面照'}, 
        IDBackImage: {label: '身份证反面照'}  
    },
    CAN: {
        name: {label: '姓名', isMandatory: true},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'国家/地区', isMandatory: true},
        institution: {label: '公司/机构'},
        postalCode: {label: '邮政编码', isMandatory: true},

        address1: {label: '地址1', isMandatory: true},
        address2: {label: '地址2'},
        address3: {label:'市', isMandatory: true},
        address4: {label: '省', isMandatory: true, 
                   options: [
                        {key:'Alberta', label:'Alberta'},
                        {key:'British Columbia', label:'British Columbia'},
                        {key:'Manitoba', label:'Manitoba'},
                        {key:'New Brunswick', label:'New Brunswick'},
                        {key:'Newfoundland and Labrador', label:'Newfoundland and Labrador'},
                        {key:'Northwest Territories', label:'Northwest Territories'},
                        {key:'Nova Scotia', label:'Nova Scotia'},
                        {key:'Nunavut', label:'Nunavut'},
                        {key:'Ontario', label:'Ontario'},
                        {key:'Prince Edward Island', label:'Prince Edward Island'},
                        {key:'Quebec', label:'Quebec'},
                        {key:'Saskatchewan', label:'Saskatchewan'},
                        {key:'Yukon', label:'Yukon'}
                   ]
                  },
    },
    HKG: {
        name: {label: '姓名', isMandatory: true},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'国家/地区', isMandatory: true},
        institution: {label: '公司/机构'},
        postalCode: {label: '邮政编码'},

        address1: {label: '地址1', isMandatory: true},
        address2: {label: '地址2'},

        address3: {label: '區', placeholder:'列如 CAUSEWAY BAY  (銅鑼灣)', isMandatory: true},
        address4: {label: '地域', 
                   options:[
                       {key:'HONG KONG', label:'HONG KONG(香港)'},
                       {key:'KOWLOON', label:'KOWLOON(九龍)'},
                       {key:'NEW TERRITORIES', label:'NEW TERRITORIES(新界)'}
                    ], isMandatory: true},
    },
    MAC: {
        phoneNumber: {label: '电话', isMandatory: false},
        name: {label: '姓名', isMandatory: true},
        countryOrRegion: {label:'国家/地区', isMandatory: true},
        institution: {label: '公司/机构'},
        postalCode: {label: '邮政编码'},

        address1: {label: '地址1', isMandatory: true},
        address2: {label: '地址2'},
        address3: {label:'地址3'},
        address4: {label: '區域', 
                   options:[
                       {key:"Macau Peninsula", label:'澳門半島(Macau Peninsula)'},
                       {key:"Taipa", label:'氹仔(Taipa)'},
                       {key:"Coloane", label:'路環(Coloane)'},
                       {key:"Cotai", label:'路氹(Cotai)'}
                    ], isMandatory: true},
    },
    TWN: {
        name: {label: '姓名', isMandatory: true},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'国家/地区', isMandatory: true},
        institution: {label: '公司/机构'},
        postalCode: {label: '邮政编码'},

        address1: {label: '地址1', isMandatory: true},
        address2: {label: '地址2'},
        address3: {label:'鄉鎮市區', isMandatory: true},
        address4: {label: '縣市', isMandatory: true,
        options:[
            {key:'基隆市', label:'基隆市'},
            {key:'台北市', label:'台北市'},
            {key:'新北市', label:'新北市'},
            {key:'桃園縣', label:'桃園縣'},
            {key:'新竹市', label:'新竹市'},
            {key:'新竹縣', label:'新竹縣'},
            {key:'苗栗縣', label:'苗栗縣'},
            {key:'台中市', label:'台中市'},
            {key:'彰化縣', label:'彰化縣'},
            {key:'南投縣', label:'南投縣'},
            {key:'雲林縣', label:'雲林縣'},
            {key:'嘉義市', label:'嘉義市'},
            {key:'嘉義縣', label:'嘉義縣'},
            {key:'台南市', label:'台南市'},
            {key:'高雄市', label:'高雄市'},
            {key:'屏東縣', label:'屏東縣'},
            {key:'台東縣', label:'台東縣'},
            {key:'花蓮縣', label:'花蓮縣'},
            {key:'宜蘭縣', label:'宜蘭縣'},
            {key:'澎湖縣', label:'澎湖縣'},
            {key:'金門縣', label:'金門縣'},
            {key:'連江縣', label:'連江縣'},
        ]
    },
    },
    "n/a": { // default 
        name: {label: '姓名', isMandatory: true},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'国家/地区', isMandatory: true},
        institution: {label: '公司/机构'},
        postalCode: {label: '邮政编码'},

        address1: {label: '地址1', isMandatory: true},
        address2: {label: '地址2'},
        address3: {label:'市'},
        address4: {label: '省'},
    },
}
const en_ShoppingAddressLabelMap: {[key:string]:ShoppingAddressSpec} = {
    CHN: {
        name: {label: 'Full Name'},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'Country/Region'},
        institution: {label: 'Company'},
        postalCode: {label: 'Postal Code'},

        address1: {label: 'Address 1'},
        address2: {label: 'Address 2'},
        address3: {label: 'City/District'},
        address4: {label: 'Province',
                   options:[
                       {key:'安徽', label:'安徽'},
                       {key:'北京', label:'北京'},
                       {key:'重庆', label:'重庆'},
                       {key:'福建', label:'福建'},
                       {key:'广东', label:'广东'},
                       {key:'甘肃', label:'甘肃'},
                       {key:'广西', label:'广西'},
                       {key:'贵州', label:'贵州'},
                       {key:'河南', label:'河南'},
                       {key:'湖北', label:'湖北'},
                       {key:'河北', label:'河北'},
                       {key:'海南', label:'海南'},
                       {key:'黑龙江', label:'黑龙江'},
                       {key:'湖南', label:'湖南'},
                       {key:'吉林', label:'吉林'},
                       {key:'江苏', label:'江苏'},
                       {key:'江西', label:'江西'},
                       {key:'辽宁', label:'辽宁'},
                       {key:'内蒙古', label:'内蒙古'},
                       {key:'宁夏', label:'宁夏'},
                       {key:'青海', label:'青海'},
                       {key:'四川', label:'四川'},
                       {key:'山东', label:'山东'},
                       {key:'上海', label:'上海'},
                       {key:'陕西', label:'陕西'},
                       {key:'山西', label:'山西'},
                       {key:'天津', label:'天津'},
                       {key:'新疆', label:'新疆'},
                       {key:'西藏', label:'西藏'},
                       {key:'云南', label:'云南'},
                       {key:'浙江', label:'浙江'},
                   ]
        },

        IDFrontImage: {label: 'ID Front Photo'}, 
        IDBackImage: {label: 'ID Back Photo'}  
    },
    CAN: {
        name: {label: 'Full Name'},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'Country/Region'},
        institution: {label: 'Company'},
        postalCode: {label: 'Postal Code'},

        address1: {label: 'Address 1'},
        address2: {label: 'Address 2'},
        address3: {label:'City'},
        address4: {label: 'Province',
                options: [
                    {key:'Alberta', label:'Alberta'},
                    {key:'British Columbia', label:'British Columbia'},
                    {key:'Manitoba', label:'Manitoba'},
                    {key:'New Brunswick', label:'New Brunswick'},
                    {key:'Newfoundland and Labrador', label:'Newfoundland and Labrador'},
                    {key:'Northwest Territories', label:'Northwest Territories'},
                    {key:'Nova Scotia', label:'Nova Scotia'},
                    {key:'Nunavut', label:'Nunavut'},
                    {key:'Ontario', label:'Ontario'},
                    {key:'Prince Edward Island', label:'Prince Edward Island'},
                    {key:'Quebec', label:'Quebec'},
                    {key:'Saskatchewan', label:'Saskatchewan'},
                    {key:'Yukon', label:'Yukon'}
            ]
        },
    },
    HKG: {
        name: {label: 'Full Name'},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'Country/Region'},
        institution: {label: 'Company'},
        postalCode: {label: 'Postal Code'},

        address1: {label: 'Address 1'},
        address2: {label: 'Address 2'},

        address3: {label: 'District', placeholder:'e.g CAUSEWAY BAY(銅鑼灣)'},
        address4: {label: 'Region', 
                   options:[
                    {key:'HONG KONG', label:'HONG KONG(香港)'},
                    {key:'KOWLOON', label:'KOWLOON(九龍)'},
                    {key:'NEW TERRITORIES', label:'NEW TERRITORIES(新界)'}
                 ]},
    },
    MAC: {
        name: {label: 'Full Name'},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'Country/Region'},
        institution: {label: 'Company'},
        postalCode: {label: 'Postal Code'},

        address1: {label: 'Address 1'},
        address2: {label: 'Address 2'},
        address3: {label:'Address 3'},
        address4: {label: 'District', 
                   options:[
                        {key:"Macau Peninsula", label:'澳門半島(Macau Peninsula)'},
                        {key:"Taipa", label:'氹仔(Taipa)'},
                        {key:"Coloane", label:'路環(Coloane)'},
                        {key:"Cotai", label:'路氹(Cotai)'}
                     ]},
    },
    TWN: {
        name: {label: 'Full Name'},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'Country/Region'},
        institution: {label: 'Company'},
        postalCode: {label: 'Postal Code'},

        address1: {label: 'Address 1'},
        address2: {label: 'Address 2'},
        address3: {label:'Town'},
        address4: {label: 'City/County',
            options:[
                {key:'基隆市', label:'基隆市'},
                {key:'台北市', label:'台北市'},
                {key:'新北市', label:'新北市'},
                {key:'桃園縣', label:'桃園縣'},
                {key:'新竹市', label:'新竹市'},
                {key:'新竹縣', label:'新竹縣'},
                {key:'苗栗縣', label:'苗栗縣'},
                {key:'台中市', label:'台中市'},
                {key:'彰化縣', label:'彰化縣'},
                {key:'南投縣', label:'南投縣'},
                {key:'雲林縣', label:'雲林縣'},
                {key:'嘉義市', label:'嘉義市'},
                {key:'嘉義縣', label:'嘉義縣'},
                {key:'台南市', label:'台南市'},
                {key:'高雄市', label:'高雄市'},
                {key:'屏東縣', label:'屏東縣'},
                {key:'台東縣', label:'台東縣'},
                {key:'花蓮縣', label:'花蓮縣'},
                {key:'宜蘭縣', label:'宜蘭縣'},
                {key:'澎湖縣', label:'澎湖縣'},
                {key:'金門縣', label:'金門縣'},
                {key:'連江縣', label:'連江縣'},
            ]
        },
    },
    'n/a': {
        name: {label: 'Full Name'},
        phoneNumber: {label: '电话', isMandatory: false},
        countryOrRegion: {label:'Country/Region'},
        institution: {label: 'Company'},
        postalCode: {label: 'Postal Code'},

        address1: {label: 'Address 1'},
        address2: {label: 'Address 2'},
        address3: {label:'City'},
        address4: {label: 'Province'},
    },
}
export const dflt_ShoppingAddressSpecMap:{[key:string]:  {[key:string]:ShoppingAddressSpec} } = {
    'en': en_ShoppingAddressLabelMap,
    'zh-CN':zh_CN_ShoppingAddressSpecMap
}    


export const zh_CN_product1: ShoppingProductDetail={
    productImageList: ['https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/CAP106-021-0001_0.png?time=1625972105101',
                       'https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/CAP302-021-0003.png?time=1625972105101',
                       'https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/CAP108-021-0016.png?time=1625972105101'],
    productName: 'CAP 力波胶囊  60',
    productType: 'chanpin',
    price: 36.99,
    currencyCode: 'CAD',
    originalPrice: 46.99,
    documentId: 'db7e1a1c-ed53-4b0b-8cae-ea52ce106a1d',
    productCode: 'NFH108-021-0046',
    headers: [
        {name:'field_origin', label: '原产地', value: '加拿大' }, 
        {name:'field_teshushangshi', label: '特殊膳食', value: '非转基因, 素食, 无激素, 果寡糖' }, 
        {name:'field_pizhunjigou', label: '批准机构', value: '加拿大卫生部' }, 
        {name:'field_chanpinbianhao', label: '编号', value: 'GNG8001-20001' }, 
    ],
    requireHealthAdviceMessage: '此产品需要专业人士开健康建议书，请联络您的注册执业营养师获取.',
    tabs: [
        {name:'description', label:'描述', 
         value:`每个胶囊600毫克α硫辛酸。高度稳定的DL-α硫辛酸形式。包含关键补充营养素B1和{#生物素}。
         Alpha Lipoic Acid 是一种非常重要的类似维生素的抗氧化剂，直到1988年才被发现。它不是真正的维生素，因为它实际上可以由您的身体制造，并且不被认为是人体中的关键元素。饮食。但是，许多人认为它是补充它在保护人类健康中的作用至关重要！实际上，它通常被称为“自由基战士之王”，因为它是目前唯一已知的既脂肪又水溶性的抗氧化剂。自由基是高反应性和非常不稳定的分子，会损害我们的身体组织。自由基是由环境污染，香烟烟雾，药物，酒精，疾病和压力产生或发现的。因此，由于我们经常暴露于大量自由基中，因此在日常生活中对强效抗氧化剂的需求极为重要。这就是α硫辛酸的来源。α硫辛酸是一种有趣的抗氧化剂，因为它很容易通过我们细胞膜的壁吸收，因此能够防止自由基对细胞内蛋白质和DNA结构的氧化损伤。大多数抗氧化剂无法穿过细胞壁，只能提供外部细胞保护。一旦进入细胞，α硫辛酸会进一步分解为听起来复杂的抗氧化剂，称为二氢硫辛酸。这种新形式的α硫辛酸能够清除有害的超氧化物，氢过氧和羟基自由基。为什么这些氧化物如此危险？因为它们就是我们每天通过接触香烟烟雾，汽车尾气，污染和酒精而遇到的问题。当我们呼吸，代谢食物或生病时，我们甚至会在不知不觉中自行产生其他有害氧化物。随着年龄的增长，我们自己生产的抗氧化剂会越来越少，我们越来越无法制造和回收关键抗氧化剂，例如维生素E，维生素C和辅酶Q-10。 α硫辛酸确实是独一无二的，因为它实际上可以再生这些抗氧化剂和其他抗氧化剂，帮助它们在体内停留更长的时间，并继续中和自由基的工作。 α硫辛酸改善神经传导和血液流动，并减少氧化应激。已经针对重金属排毒，血糖控制，肝病等方面研究了α硫辛酸。某次人研究认为，α硫辛酸是迄今为止发现的最重要的抗氧化剂。听起来我们都应该注意！ 本品可提供600毫克安全和稳定形式的α硫辛酸治疗剂量。该配方辅以硫胺素和{#生物素}，因为这些营养物质尤其可能不足或彼此竞争吸收进入细胞。研究表明，如果在没有硫胺素支持的情况下服用高剂量的α硫辛酸，则那些具有硫胺素缺乏症的人（例如患有消化系统疾病或大量饮酒的人）会出现毒副作用。{#生物素}缺乏症可能是由于高剂量的α硫辛酸引起的，因为它们似乎彼此竞争穿过细胞壁。除非服用额外的{#生物素}，否则α硫辛酸通常会胜出，并且会出现缺乏症。将它们组合为一个公式可确保它们作为平等的伙伴而不是竞争者。`, 
         display:['mark_terms', 'tap_to_enlarge']},
        
         {name:'general', label:'基本信息',
          fieldList:[
              {name:'field_baozhuanyangshi', label:'包装样式', value:'60粒/瓶装'},
              {name:'field_jixinfenglei', label:'剂型分类', value:'植物胶囊'},
              {name:'field_feigongxiaochengfeng', label:'非功效成分', value:'蔬菜级硬脂酸镁, 蔬菜胶囊, 微晶纤维素'},
              {name:'field_baozhuanyangshi', label:'包装样式', value:'60粒/瓶装'},
              {name:'field_piwenhaomai', label:'批文号码', value:'80029600'},
              {name:'field_pizhunjigou', label:'批准机构', value:'加拿大卫生部'},
          ]
         },

         {name:'field_shiyongfangwei',label:'适用范围', value:'有助于促进健康的葡萄糖代谢，帮助人体代谢碳水化合物。', 
          display:['mark_terms', 'tap_to_enlarge']},

         {name:'field_shiyongzhiyin', label:'使用指引', value:'成人，每日1次，每次1粒。或遵注册执业营养师/注册健康管理师指示。',
          display:['tap_to_enlarge']},
         {name:'field_fengxiantishi',label:'风险提示', value:'如患有糖尿病，怀孕或哺乳，请在使用前咨询注册执业营养师/注册健康管理师。如出汗，面色，发冷，头痛，头晕或神志不清，请停止使用并咨询注册执业营养师/注册健康管理师，因为这些可能是严重的低血糖症状。',
          display:['is_warning', 'tap_to_enlarge']},
         {name:'field_jinjizheng', label:'禁忌症', value:'adfasfas', display:['is_warning', 'tap_to_enlarge']},
         
         {name:'field_buliangfangyin', label:'已知不良反应', value:'可能引起恶心，呕吐，腹泻，腹部绞痛；如症状严重，请停止使用并咨询注册执业营养师/注册健康管理师。',
            display:['is_warning', 'tap_to_enlarge']
          },
        
        // {name:'field_gongxiaochengfen', label:'功效成份', tableData:[
        //     [
        //         {name:'yanliaomingchen', label:'原料名称', value:'DL-硫辛酸'},
        //         {name:'yanliao_latin_mingchen', label:'拉丁文名称', value:'DL-Alpha lipoic acid'},
        //         {name:'yanliaohangliang', label:'原料含量', value:'600毫克'},
        //     ],
        //     [
        //         {name:'yanliaomingchen', label:'原料名称', value:'生物素'},
        //         {name:'yanliao_latin_mingchen', label:'拉丁文名称', value:'DL-Alpha lipoic acid'},
        //         {name:'yanliaohangliang', label:'原料含量', value:'600毫克'},
        //     ],
        //     [
        //         {name:'yanliaomingchen', label:'原料名称', value:'维生素B1（盐酸硫胺素）'},
        //         {name:'yanliao_latin_mingchen', label:'拉丁文名称', value:'Biotin'},
        //         {name:'yanliaohangliang', label:'原料含量', value:'200微克'},
        //     ],
        // ]}  
    ],

    ingredients:[
        {name:'DL-Alpha lipoic acid', cName:'DL-硫辛酸',cpName:'DL-硫辛酸', amount:'600毫克'},
        {name:'Biotin', cName:'生物素',cpName:'生物素', amount:'600毫克'},
    ]

};

export const en_product1: ShoppingProductDetail={
    productImageList: ['https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/CAP106-021-0001_0.png?time=1625972105101'],
    productName: 'CAP Alpha Lipoic Acid 600mg',
    price: 36.99,
    currencyCode: 'CAD',
    originalPrice: 46.99,
    documentId: 'db7e1a1c-ed53-4b0b-8cae-ea52ce106a1d',
    productCode: 'NFH108-021-0046',
    productType: 'chanpin',

    headers: [
        {name:'field_origin', label: 'origin', value: 'Canada' }, 
        {name:'field_teshushangshi', label: 'Special Dietary', value: '非转基因, 素食, 无激素, 果寡糖' }, 
        {name:'field_pizhunjigou', label: 'Approved By', value: 'Ministry Of Health, Canada' }, 
        {name:'field_chanpinbianhao', label: 'Product Code', value: 'GNG8001-20001' }, 
    ],
    requireHealthAdviceMessage: '此产品需要专业人士开具健康建议书，请联络您的注册执业营养师获取.',
    tabs: [
        {name:'description', label:'Description', 
         value:'在运动过程中有助于补充枯竭的矿物质。 本品可以补充重要的矿物质，这些矿物质在运动和身体紧张时或运动后可能会耗尽。 钠，钾，氯，钙和镁等矿物质的流失会导致疲劳，脱水和肌肉痉挛。 胶囊形式可以轻松自定义剂量，以满足患者的个性化训练和性能需求，同时还提供便捷的便利性，非常适合在旅途中进行补充。', 
         display:['mark_terms', 'tap_to_enlarge']},
        
         {name:'general', label:'General',
          fieldList:[
              {name:'field_baozhuanyangshi', label:'Package', value:'60粒/瓶装'},
              {name:'field_jixinfenglei', label:'Pills', value:'植物胶囊'},
              {name:'field_feigongxiaochengfeng', label:'Non-Medicinal Ingredients', value:'蔬菜级硬脂酸镁, 蔬菜胶囊, 微晶纤维素'},
              {name:'field_piwenhaomai', label:'NPN', value:'80029600'},
              {name:'field_pizhunjigou', label:'Approved By', value:'Ministry Of Health, Canada'},
          ]
         },

         {name:'field_shiyongfangwei',label:'Purpose', value:'有助于促进健康的葡萄糖代谢，帮助人体代谢碳水化合物。', 
          display:['mark_terms', 'tap_to_enlarge']},

         {name:'field_shiyongzhiyin', label:'Dosage', value:'成人，每日1次，每次1粒。或遵注册执业营养师/注册健康管理师指示。',
          display:['tap_to_enlarge']},
         {name:'field_fengxiantishi',label:'Caution', value:'如患有糖尿病，怀孕或哺乳，请在使用前咨询注册执业营养师/注册健康管理师。如出汗，面色，发冷，头痛，头晕或神志不清，请停止使用并咨询注册执业营养师/注册健康管理师，因为这些可能是严重的低血糖症状。',
          display:['is_warning', 'tap_to_enlarge']},
         {name:'field_jinjizheng', label:'禁忌症', value:'adfasfas', display:['is_warning', 'tap_to_enlarge']},
         
         {name:'field_buliangfangyin', label:'Adversary Effect', value:'可能引起恶心，呕吐，腹泻，腹部绞痛；如症状严重，请停止使用并咨询注册执业营养师/注册健康管理师。',
            display:['is_warning', 'tap_to_enlarge']
          },
    ],
    ingredients:[]
}

export const zh_CN_product2: ShoppingProductDetail={
    productImageList: ['https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/MET108-021-0017.png?time=1625972105101'],
    productName: 'MET 西隆尼片 120',
    price: 35.79,
    currencyCode: 'CNY',
    documentId: 'db7e1a1c-ed53-4b0b-8cae-ea52ce106a1d',
    productCode: 'NFH108-021-0046',
    productType: 'chanpin',

    headers: [
        {name:'field_origin', label: '原产地', value: '加拿大' }, 
        {name:'field_teshushangshi', label: '特殊膳食', value: '非转基因, 素食, 无激素, 果寡糖' }, 
        {name:'field_pizhunjigou', label: '批准机构', value: '加拿大卫生部' }, 
        {name:'field_chanpinbianhao', label: '编号', value: 'GNG8001-20001' }, 
    ],
    tabs: [
        {name:'description', label:'描述', 
         value:'在运动过程中有助于补充枯竭的矿物质。 本品可以补充重要的矿物质，这些矿物质在运动和身体紧张时或运动后可能会耗尽。 钠，钾，氯，钙和镁等矿物质的流失会导致疲劳，脱水和肌肉痉挛。 胶囊形式可以轻松自定义剂量，以满足患者的个性化训练和性能需求，同时还提供便捷的便利性，非常适合在旅途中进行补充。', 
         display:['mark_terms', 'tap_to_enlarge']},
        
         {name:'general', label:'基本信息',
          fieldList:[
              {name:'field_baozhuanyangshi', label:'包装样式', value:'60粒/瓶装'},
              {name:'field_jixinfenglei', label:'剂型分类', value:'植物胶囊'},
              {name:'field_feigongxiaochengfeng', label:'非功效成分', value:'蔬菜级硬脂酸镁, 蔬菜胶囊, 微晶纤维素'},
              {name:'field_baozhuanyangshi', label:'包装样式', value:'60粒/瓶装'},
              {name:'field_piwenhaomai', label:'批文号码', value:'80029600'},
              {name:'field_pizhunjigou', label:'批准机构', value:'加拿大卫生部'},
          ]
         },

        {name:'field_shiyongfangwei',label:'适用范围', 
         value:'有助于促进健康的葡萄糖代谢，帮助人体代谢碳水化合物。', 
         display:['mark_terms', 'tap_to_enlarge']},

        {name:'field_shiyongzhiyin', label:'使用指引', value:'成人，每日1次，每次1粒。或遵注册执业营养师/注册健康管理师指示。',
         display:['tap_to_enlarge']},
        {name:'field_fengxiantishi',label:'风险提示', value:'如患有糖尿病，怀孕或哺乳，请在使用前咨询注册执业营养师/注册健康管理师。如出汗，面色，发冷，头痛，头晕或神志不清，请停止使用并咨询注册执业营养师/注册健康管理师，因为这些可能是严重的低血糖症状。',
         display:['is_warning', 'tap_to_enlarge']},
        {name:'field_jinjizheng', label:'禁忌症', value:'adfasfas', display:['is_warning', 'tap_to_enlarge']},
        
        {name:'field_buliangfangyin', label:'已知不良反应', value:'可能引起恶心，呕吐，腹泻，腹部绞痛；如症状严重，请停止使用并咨询注册执业营养师/注册健康管理师。',
         display:['is_warning', 'tap_to_enlarge']
        },

        {name:'field_gongxiaochengfen', label:'功效成份', tableData:[
            [
                {name:'yanliaomingchen', label:'原料名称', value:'镁（L-苏糖酸镁'},
                {name:'yanliao_latin_mingchen', label:'拉丁文名称', value:'Magnesium (magnesium L-threonate)'},
                {name:'yanliaohangliang', label:'原料含量', value:'49毫克'},
            ]
         ]
        }  
    ],
    ingredients:[]
};

export const en_product2: ShoppingProductDetail={
    productImageList: ['https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/MET108-021-0017.png?time=1625972105101'],
    productName: 'MET Mag L-Threonate™',
    price: 35.79,
    currencyCode: 'CNY',
    documentId: 'db7e1a1c-ed53-4b0b-8cae-ea52ce106a1d',
    productCode: 'NFH108-021-0046',
    productType: 'chanpin',

    headers: [
        {name:'field_origin', label: 'origin', value: 'Canada' }, 
        {name:'field_teshushangshi', label: 'Special Dietary', value: '非转基因, 素食, 无激素, 果寡糖' }, 
        {name:'field_pizhunjigou', label: 'Approved By', value: 'Ministry Of Health, Canada' }, 
        {name:'field_chanpinbianhao', label: 'Product Code', value: 'GNG8001-20001' }, 
    ],
    tabs: [
        {name:'description', label:'Description', 
         value:'在运动过程中有助于补充枯竭的矿物质。 本品可以补充重要的矿物质，这些矿物质在运动和身体紧张时或运动后可能会耗尽。 钠，钾，氯，钙和镁等矿物质的流失会导致疲劳，脱水和肌肉痉挛。 胶囊形式可以轻松自定义剂量，以满足患者的个性化训练和性能需求，同时还提供便捷的便利性，非常适合在旅途中进行补充。', 
         display:['mark_terms', 'tap_to_enlarge']},
        
         {name:'general', label:'General',
          fieldList:[
              {name:'field_baozhuanyangshi', label:'Package', value:'60粒/瓶装'},
              {name:'field_jixinfenglei', label:'Pills', value:'植物胶囊'},
              {name:'field_feigongxiaochengfeng', label:'Non-Medicinal Ingredients', value:'蔬菜级硬脂酸镁, 蔬菜胶囊, 微晶纤维素'},
              {name:'field_piwenhaomai', label:'NPN', value:'80029600'},
              {name:'field_pizhunjigou', label:'Approved By', value:'Ministry Of Health, Canada'},
          ]
         },

         {name:'field_shiyongfangwei',label:'Purpose', value:'有助于促进健康的葡萄糖代谢，帮助人体代谢碳水化合物。', 
          display:['mark_terms', 'tap_to_enlarge']},

         {name:'field_shiyongzhiyin', label:'Dosage', value:'成人，每日1次，每次1粒。或遵注册执业营养师/注册健康管理师指示。',
          display:['tap_to_enlarge']},
         {name:'field_fengxiantishi',label:'Caution', value:'如患有糖尿病，怀孕或哺乳，请在使用前咨询注册执业营养师/注册健康管理师。如出汗，面色，发冷，头痛，头晕或神志不清，请停止使用并咨询注册执业营养师/注册健康管理师，因为这些可能是严重的低血糖症状。',
          display:['is_warning', 'tap_to_enlarge']},
         {name:'field_jinjizheng', label:'禁忌症', value:'adfasfas', display:['is_warning', 'tap_to_enlarge']},
         
         {name:'field_buliangfangyin', label:'Adversary Effect', value:'可能引起恶心，呕吐，腹泻，腹部绞痛；如症状严重，请停止使用并咨询注册执业营养师/注册健康管理师。',
            display:['is_warning', 'tap_to_enlarge']
          },
    ],
    ingredients:[]
}

const _licenceExpireDate = new Date();
{
    _licenceExpireDate.setFullYear(2023, 10, 12);
}

export function generateSampleNutritionistList():NutritionistInfo[]{ 
    let list = [] as NutritionistInfo[];
    for(let i=0; i<23; i++){
        list.push({
            name:'张威',
            username:(15413+i)+'',
            officeEmail:'zhang876@163.com',
            officePhone:'1393463467',
            businessAddress:{
                addressId: '214124',
                countryOrRegion:'CHN',
                address1: '芷泉街229号',
                address2: '锦江区',
                address3: '成都市',
                address4: '',
            }, 
            gender:'female',
            serviceTime: [
                {
                    from: 10, to: 18,
                    dayOfWeek: [0,1,2,3,4,5,6],
                    id: 1434542,
                    timeZone: 8,
                }
            ],
            // serviceTime:'10AM - 6PM 北京时间',
            expertIn:'痛风，糖尿病. 同济医学院毕业',
            qrCode: { 
                code: 'q345325234535352ewwtgegsdgdgfdsfgsd',
                base64Image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/330px-QR_code_for_mobile_English_Wikipedia.svg.png'
            },
            license:{
                nutritionistUsername: '25qsvndfndas',
                name:'Julia Wong',
                regNumber:'645325353',
                insurancePolicyNumber: '64545553523',
                category:'CPNL2',
                employer:'Julia CPN Clinic',
                expiration:_licenceExpireDate.getTime(),
                licenceImage:{url: licenceImage, photoId: '135134214'}
            },
        });
        list.push({
            name:'Julia Wong',
            username:(25413+i)+'',
            officeEmail:'julianwang123@gmail.com',
            officePhone:'+1-416-765-987',
            businessAddress:{
                addressId: '214125',
                countryOrRegion:'CAN',
                address1: '123 Baton Road',
                address2: 'Markham',
                address3: 'Ontario',
                address4: '',
                postalCode: 'L4J 8V9'
            },
            qrCode:{
                code: '163543465464535345gsdgdfgdgdsgds',
                base64Image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/330px-QR_code_for_mobile_English_Wikipedia.svg.png'
            },
            license:{
                nutritionistUsername: 'abhgdfdasfasfa',
                name:'Julia Wong',
                regNumber:'645325353',
                insurancePolicyNumber: '264235235',
                category:'CPNL2',
                employer:'Julia CPN Clinic',
                expiration:_licenceExpireDate.getTime(),
                licenceImage:{url: licenceImage, photoId: '135134214'}
            },
        })

    }
    return list;
}


export const zh_CN_NutritionistDetail:NutritionistInfo = {
    name:'张威',
    username:'15413',
    officeEmail:'zhang876@163.com',
    officePhone:'1393463467',
    businessAddress:{
        addressId: '214124',
        countryOrRegion:'CHN',
        address1: '芷泉街229号',
        address2: '锦江区',
        address3: '成都市',
        address4: '',
    },
    serviceTime: [
        {
            from: 10, to: 18,
            dayOfWeek: [0,1,2,3,4,5,6],
            id: 1434542,
            timeZone: 8,
        }
    ],
    gender:'female',
    qrCode: {
        code: 'aasgasfasfdsfasfasfafafa',
        base64Image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/330px-QR_code_for_mobile_English_Wikipedia.svg.png'
    },
    license:{
        nutritionistUsername: 'afasdfasfasfasfasfas',
        name:'Julia Wong',
        regNumber:'645325353',
        insurancePolicyNumber: 'afasfdasfasfa',
        category:'CPNL2',
        employer:'Julia CPN Clinic',
        expiration:_licenceExpireDate.getTime(),
        licenceImage:{url: licenceImage, photoId: '135134214'}
    },
    expertIn:'痛风，糖尿病. 同济医学院毕业',
}

export function genSampleClients():NutritionistClient[]{
    let list = [] as NutritionistClient[];

    for(let i=0; i<23; i++){
        list.push({
            active: true,
            clientUsername: Date.now() + '.'+i,
            client:'魏其侯',
            email:'zhang876@163.com',
            address: {
                addressId: '341341',
                countryOrRegion:'CHN',
                address1:'万昌街1号',
                address2: '双阳区',
                address3: '长春市',
                address4: '',
            }, 
            phoneNumber:'1393463467',
            time: Date.now()-1000*3600*24*6,
            notes: '肩周炎',
        });
        list.push({
            active: false,
            clientUsername: Date.now() + '.'+i+30,
            client:'Jane Zhang',
            email:'jane.zhang@gmail.com',
            address:{
                addressId: '7546',
                countryOrRegion: 'CAN',
                address1: '55 York Street',
                address2: 'Toronto',
                address3: 'Ontario',
                address4: '',
            },
            phoneNumber:'1-416-543-9876',
            time: Date.now()-1000*3600*24*9,
            notes: '胃酸多'
        })
    }
    
    return list;
}

const zh_CN_HealthAdviceStatusOptions:{key:HealthAdviceStatus|'', text:string}[] = [
    {key:'', text:'任何状态'},
    {key:'READY', text:'创建'},
    {key:'VOIDED', text:'取消'},
    {key:'IN_CART', text:'在购物车里'},
    {key:'EXPIRED', text:'失效'},
    {key:'USED', text:'在订单里'},
];
const en_HealthAdviceStatusOptions:{key:HealthAdviceStatus|'', text:string}[] = [
    {key:'', text:'any state'},
    {key:'READY', text:'Created'},
    {key:'VOIDED', text:'Cancelled'},
    {key:'IN_CART', text:'In Shopping Cart'},
    {key:'EXPIRED', text:'Expired'},
    {key:'USED', text:'Applied'},
];
export const dflt_HealthAdviceStatusOptions:{[key:string]:  {key:HealthAdviceStatus|'', text:string}[] } = {
    "en": en_HealthAdviceStatusOptions,
    "zh-CN": zh_CN_HealthAdviceStatusOptions
};


export function genSampleHealthAdviceByMe(languageCode:string):Promise<NutritionistHealthAdvice[]>{
    let healthAdviceList:NutritionistHealthAdvice[] = [];

    for(let i=0; i<22; i++){
        healthAdviceList.push({
            clientUsername: 'afasdfasfasfa',
            nutritionistUsername: 'qagfdasfas',
            client:{
                active: true,
                clientUsername: Date.now()+'.'+i,
                client:'魏其侯',
                email:'zhang876@163.com',
                address: {
                    addressId: '341341',
                    countryOrRegion:'CHN',
                    address1:'万昌街1号',
                    address2: '双阳区',
                    address3: '长春市',
                    address4: '',
                },
                phoneNumber:'1393463467',
                time: Date.now()-1000*3600*24*6,
                notes: '肩周炎',
            },
            prescriptionCode:'634523',
            createdDtm:Date.now()-1000*3600*24*10,
            modifiedTime: Date.now(),
            title:'降低胃酸',
            description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
            expiration: Date.now()+1000*3600*24*10,
            state:'READY',
            item:[
                {
                    productCode:'GNG8001-20001',
                    productName:'MET 西隆尼片 120',
                    count: 2,
                    productType:'chanpin',
                    keyIngredient:[
                        {   name: 'Magnesium (magnesium L-threonate)',
                            cName: '镁（L-苏糖酸镁)',
                            cpName: '镁（L-苏糖酸镁)',
                            amount: '600mg'
                        } 
                    ]
                },
                {
                    productCode:'CAP 力波胶囊  60',
                    productName:'GNG8001-20001',
                    count: 1,
                    productType:'chanpin',
                    keyIngredient:[
                        {
                            cName:'DL-硫辛酸',
                            cpName:'DL-硫辛酸',
                            name:'DL-Alpha lipoic acid',
                            amount: '400mg',
                        },
                        {
                            cName:'维生素B1（盐酸硫胺素）',
                            cpName:'维生素B1（盐酸硫胺素）',
                            name:'Biotin',
                            amount: '230mg',
                        }
                    ]
                }
            ]
        });
        healthAdviceList.push({
            clientUsername: 'afasdfafasfas',
            nutritionistUsername: 'qagfdasfas',
            client:{
                active: false,
                clientUsername: Date.now()+'.'+30,
                client:'Jane Zhang',
                email:'jane.zhang@gmail.com',
                address:{
                    addressId: '7546',
                    countryOrRegion: 'CAN',
                    address1: '55 York Street',
                    address2: 'Toronto',
                    address3: 'Ontario',
                    address4: '',
                },
                phoneNumber:'1-416-543-9876',
                time: Date.now()-1000*3600*24*9,
                notes: '胃酸多'
            },
            prescriptionCode:'634523',
            createdDtm:Date.now()-1000*3600*24*10,
            modifiedTime: Date.now(),
            title:'降低胃酸',
            description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
            expiration: Date.now()+1000*3600*24*10,
            state:'READY',
            item:[
                {
                    productCode:'GNG8001-20001',
                    productName:'MET 西隆尼片 120',
                    count: 2,
                    productType:'chanpin',
                    keyIngredient:[
                        {   name: 'Magnesium (magnesium L-threonate)',
                            cName: '镁（L-苏糖酸镁)',
                            cpName: '镁（L-苏糖酸镁)',
                            amount: '600mg'
                        } 
                    ]
                },
                {
                    productCode:'CAP 力波胶囊  60',
                    productName:'GNG8001-20001',
                    count: 1,
                    productType:'chanpin',
                    keyIngredient:[
                        {
                            cName:'DL-硫辛酸',
                            cpName:'DL-硫辛酸',
                            name:'DL-Alpha lipoic acid',
                            amount: '400mg',
                        },
                        {
                            cName:'维生素B1（盐酸硫胺素）',
                            cpName:'维生素B1（盐酸硫胺素）',
                            name:'Biotin',
                            amount: '230mg',
                        }
                    ]
                }
            ]
        })
    }

    return asyncDelay(healthAdviceList, 400);
}


export function genSampleClientHealthAdvice(languageCode:string):Promise<ClientHealthAdvice[]>{
    let healthAdviceList:ClientHealthAdvice[] = [];

    for(let i=0; i<22; i++){
        healthAdviceList.push({
            clientUsername: 'zvzxvzxvzx',
            nutritionistUsername: 'afasdfasfasf',
            prescriptionCode:'634523',
            createdDtm:Date.now()-1000*3600*24*10,
            modifiedTime: Date.now(),
            title:'降低胃酸',
            description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
            expiration: Date.now()+1000*3600*24*10,
            state:'READY',
            item:[
                {
                    productCode:'GNG8001-20001',
                    productName:'MET 西隆尼片 120',
                    count: 2,
                    productType:'chanpin',
                    keyIngredient:[
                        {   name: 'Magnesium (magnesium L-threonate)',
                            cName: '镁（L-苏糖酸镁)',
                            cpName: '镁（L-苏糖酸镁)',
                            amount: '600mg'
                        }                         
                    ]
                },
                {
                    productCode:'CAP 力波胶囊  60',
                    productName:'GNG8001-20001',
                    count: 1,
                    productType:'chanpin',
                    keyIngredient:[
                        {
                            cName:'DL-硫辛酸',
                            cpName:'DL-硫辛酸',
                            name:'DL-Alpha lipoic acid',
                            amount: '400mg',
                        },
                        {
                            cName:'维生素B1（盐酸硫胺素）',
                            cpName:'维生素B1（盐酸硫胺素）',
                            name:'Biotin',
                            amount: '230mg',
                        }                        
                    ]
                }
            ],
            nutritionist:{
                name:'张威',
                username:(15413+i)+'',
                officeEmail:'zhang876@163.com',
                officePhone:'1393463467',
                businessAddress:{
                    addressId: '214124',
                    countryOrRegion:'CHN',
                    address1: '芷泉街229号',
                    address2: '锦江区',
                    address3: '成都市',
                    address4: '',
                },
                gender:'female',
                expertIn:'痛风，糖尿病. 同济医学院毕业'
            }
        });
        healthAdviceList.push({
            clientUsername: 'zvzxvzxvzx',
            nutritionistUsername: 'afasfdasfas',
            prescriptionCode:'634523',
            createdDtm:Date.now()-1000*3600*24*10,
            modifiedTime: Date.now(),
            title:'降低胃酸',
            description:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
            expiration: Date.now()+1000*3600*24*10,
            state:'READY',
            item:[
                {
                    productCode:'GNG8001-20001',
                    productName:'MET 西隆尼片 120',
                    count: 2,
                    productType:'chanpin',
                    keyIngredient:[
                        {   name: 'Magnesium (magnesium L-threonate)',
                            cName: '镁（L-苏糖酸镁)',
                            cpName: '镁（L-苏糖酸镁)',
                            amount: '600mg'
                        }                         
                    ]
                },
                {
                    productCode:'CAP 力波胶囊  60',
                    productName:'GNG8001-20001',
                    count: 1,
                    productType:'chanpin',
                    keyIngredient:[
                        {
                            cName:'DL-硫辛酸',
                            cpName:'DL-硫辛酸',
                            name:'DL-Alpha lipoic acid',
                            amount: '400mg',
                        },
                        {
                            cName:'维生素B1（盐酸硫胺素）',
                            cpName:'维生素B1（盐酸硫胺素）',
                            name:'Biotin',
                            amount: '230mg',
                        }                        
                    ]
                }
            ],
            nutritionist:{
                name:'张威',
                username:(15413+i)+'',
                officeEmail:'zhang876@163.com',
                officePhone:'1393463467',
                businessAddress:{
                    addressId: '214124',
                    countryOrRegion:'CHN',
                    address1: '芷泉街229号',
                    address2: '锦江区',
                    address3: '成都市',
                    address4: '',
                },
                gender:'female',
                expertIn:'痛风，糖尿病. 同济医学院毕业'
            }
        })
    }

    return asyncDelay(healthAdviceList, 400);
}

export const sampleShoppingCart:ShoppingCartRecord = {
    items: [
        {
            type:'HEALTH_ADVICE',
            toBeCheckedOut: true,
            healthAdviceCode: '2642253',
            products:[
                {
                    type:'PRODUCT',
                    toBeCheckedOut: true,
                    productImage: 'https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/MBL309-021-0002.jpg?time=1628183733448',
                    productName:'CNR 免疫支持( 150)',
                    productCode:'ROF001-20-001',
                    price: 52.24,
                    currencyCode:'CAD',
                    count:1,
                    totalPrice: 52.24,
                    weight: 250,
                    weightCode: 'g',
                    totalWeight: 250,
                },
                {
                    type:'PRODUCT',
                    toBeCheckedOut: true,
                    productImage: 'https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/CAP308-021-0007.png?time=1628183733448',
                    productName:'CAP 特洛普罗F胶囊  60',
                    productCode:'CAP308-021-0007',
                    price: 72.19,
                    currencyCode:'CAD',
                    count:2,
                    totalPrice: 144.38,
                }
            ]
        },
        {
            type: 'PRODUCT',
            toBeCheckedOut: true,
            productImage: 'https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/GEN305-021-0003.jpg?time=1628183733448',
            productCode: 'GD007-20-001',
            productName: 'DFH 助眠胶囊（180)',
            originalPrice: 92.19,
            price: 72.19,
            currencyCode:'CAD',
            count:1,
            totalPrice: 72.19,
        }
    ],
    couponCode: '1421343',
    useCoupon: true,
    summary:{
        totalWeight: 0.7,
        weightCode: 'kg',
        subTotal: 268.81,
        currencyCode: 'CAD',
        discounts: [
            {
                discount: 50,
                discountDescription: '使用优惠券',        
            }
        ],
        total: 218.81
    }
}

export const sampleBillingAddresses:BillingAddress[]=[
    {
        addressId: '43522',
        name: '李明锐',
        countryOrRegion: 'CHN',
        postalCode: '20009',
        address1: '玉清园9栋908室',
        address2: '秦淮区',
        address3: '南京',
        address4: '江苏',
        username: 'afasdfasfasf',
    },
    {
        addressId: '43523',
        name: '李玉龍',
        countryOrRegion: 'TWN',
        postalCode: '822',
        address1: '106巷 52弄	32號 309室',
        address2: '建國北路2段',
        address3: '南區',
        address4: '台中市',
        username: 'afasdfasfasf',
    }
]

export const samplePickupAddresses:ShoppingPickupAddress[] = [
    {
        addressId:'1341412',
        countryOrRegion:'CAN',
        postalCode: 'M1V 0B7',
        address1: 'Splendid China Tower(锦绣中华) Unit 2D22-2D23',
        address2: '4675 Steeles Ave',
        address3: 'Scarborough',
        address4: 'Ontario',
        comment: `1:30Pm-5Pm Mon-Sat (周一到周六1:30Pm-5PM)\n647-787-1072 (Julia Wong)`,
        name: 'Julia Wong',
        phoneNumber: '647-787-1072',
        pharmacyId: 'q32534'
    },
    {
        addressId:'2341412',
        countryOrRegion:'CAN',
        postalCode: 'L4K 1Z8',
        address1: 'Unit 153',
        address2: '7250 Keele St',
        address3: 'Vaughan',
        address4: 'Ontario',
        comment: `12Pm-5:30Pm Wed-Sun.\n416-560-7928 (Maggie Yu)`,
        name: 'Maggie Yu',
        phoneNumber: '416-560-7928',
        pharmacyId: 'q32535'
    },
    {
        addressId:'3341412',
        countryOrRegion:'CAN',
        postalCode: 'L3R 9T3',
        address1: 'Unit 101',
        address2: '50 McIntosh Dr',
        address3: 'Markham',
        address4: 'Ontario',
        comment: `10Am-6Pm, Mon to Fri\n647-800-7875 (Kitty Chen)`,
        name: 'Kitty Chen',
        phoneNumber: '647-800-7875',
        pharmacyId: 'q32536'
    },
]

export const sampleShippingAddresses:ShippingAddress[]=[
    {
        addressId: '43522',
        name: '李明锐',
        countryOrRegion: 'CHN',
        postalCode: '20009',
        address1: '玉清园9栋908室',
        address2: '秦淮区',
        address3: '南京',
        address4: '江苏',
        identityPhoto:[
            {url: sampleFrontImage, photoId: '1343'},
            {url: sampleBackImage, photoId: '1345'}
        ],
        username: '135334532',
    },
    {
        addressId: '43523',
        name: '李玉龍',
        countryOrRegion: 'TWN',
        postalCode: '822',
        address1: '106巷 52弄	32號 309室',
        address2: '建國北路2段',
        address3: '南區',
        address4: '台中市',
        username: '135334532',
    }
];

export const sampleShoppingOrder:ShoppingOrder = {
    items: [
        {
            type:'HEALTH_ADVICE',
            toBeCheckedOut: true,
            healthAdviceCode: '2642253',
            products:[
                {
                    type:'PRODUCT',
                    toBeCheckedOut: true,
                    productImage: 'https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/MBL309-021-0002.jpg?time=1628183733448',
                    productName:'CNR 免疫支持( 150)',
                    productCode:'ROF001-20-001',
                    price: 52.24,
                    currencyCode:'CAD',
                    count:1,
                    totalPrice: 52.24,
                    weight: 250,
                    weightCode: 'g',
                    totalWeight: 250,
                },
                {
                    type:'PRODUCT',
                    toBeCheckedOut: true,
                    productImage: 'https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/CAP308-021-0007.png?time=1628183733448',
                    productName:'CAP 特洛普罗F胶囊  60',
                    productCode:'CAP308-021-0007',
                    price: 72.19,
                    currencyCode:'CAD',
                    count:2,
                    totalPrice: 144.38,
                }
            ]
        },
        {
            type: 'PRODUCT',
            toBeCheckedOut: true,
            productImage: 'https://apiserver.unishell.com:8000/server/v1/docs/picture/sites/default/files/chanpin/GEN305-021-0003.jpg?time=1628183733448',
            productCode: 'GD007-20-001',
            productName: 'DFH 助眠胶囊（180)',
            originalPrice: 92.19,
            price: 72.19,
            currencyCode:'CAD',
            count:1,
            totalPrice: 72.19,
        }
    ],
    couponCode: '1421343',
    useCoupon: true,
    summary:{
        totalWeight: 0.7,
        weightCode: 'kg',
        subTotal: 268.81,
        currencyCode: 'CAD',
        discounts: [
            {
                discount: 50,
                discountDescription: '使用优惠券',        
            }
        ],
        total: 218.81
    },

    createdTimestamp: Date.now() - 1000*60*60,
    modifiedTimestamp: Date.now() - 1000*60,

    orderId: '',
    states: [
        // {
        //     status:'创建', timestamp: Date.now() - 1000*60*60,
        // },
    ],
    billingAddress: {
        addressId: '43522',
        name: '李明锐',
        countryOrRegion: 'CHN',
        postalCode: '20009',
        address1: '玉清园9栋908室',
        address2: '秦淮区',
        address3: '南京',
        address4: '江苏',
        username: '135334532',
    },
    shippingMethod:{
        type:'pickup',
        address: {
            addressId:'2341412',
            countryOrRegion:'CAN',
            postalCode: 'L4K 1Z8',
            address1: 'Unit 153',
            address2: '7250 Keele St',
            address3: 'Vaughan',
            address4: 'Ontario',
            comment: `12Pm-5:30Pm Wed-Sun\n416-560-7928 (Maggie Yu)`,
            name: 'Maggie Yu',
            phoneNumber: '416-560-7928',
            pharmacyId: 'afasdfadsfa'
        }   
    },
    paymentMethod: "AliPay"
}


export function generateSampleShoppingOrderBreifList():ShoppingOrderBreif[] {
    const list:ShoppingOrderBreif[] = [];
    for(let i=0; i<102; i++){
        let createdTimestamp = Date.now() - 1000*3600*24*i;
        let modifiedTimestamp = createdTimestamp+1000*60;
        let total = 253.45+i*3;
        let currencyCode = 'CAD';
        let status:ShoppingOrderStatus = '已发货';
        let paymentMethod: PaymentMethod = 'CreditCard';
        let description = '';

        if(i % 3 === 1){
            currencyCode = 'UNIS';
            status = '已取件';
            paymentMethod = 'Wallet';
        }
        list.push({
            orderId: (5345555+i).toString(),
            createdTimestamp,
            modifiedTimestamp,
            currencyCode,
            total,
            status,
            paymentMethod,
            description
        })
    };

    return list;
}

const zh_CN_ShoppingOrderStatusOptions:{key:string, text:string}[]=[
    {key:'', text:'任何状态'},
    {key: 'CREATED', text:'创建'},
    {key: 'PAYMENT_PENDING', text:'付费中'},
    {key: 'PAID', text:'已付费'},
    {key: 'SHIPPED', text:'已发货'},
    {key: 'READY_FOR_PICKUP', text:'可以取件'},
    {key: 'PICKED_UP', text:'已取件'},
    {key: 'DELIVERED', text:'已签收'},
    {key: 'PAYMENT_REJECTED', text:'付费失败'},
    {key: 'CANCELLED', text:'取消'},
    {key: 'EXPIRED', text:'退货'},
];
const en_ShoppingOrderStatusOptions:{key:string, text:string}[]=[
    {key:'', text:'Any State'},
    {key: 'CREATED', text:'Created'},
    {key: 'PAYMENT_PENDING', text:'Payment Pending'},
    {key: 'PAID', text:'Paid'},
    {key: 'SHIPPED', text:'Shipped'},
    {key: 'READY_FOR_PICKUP', text:'Ready to Pickup'},
    {key: 'PICKED_UP', text:'Picked Up'},
    {key: 'DELIVERED', text:'Delivered'},
    {key: 'PAYMENT_REJECTED', text:'Payment Failed'},
    {key: 'CANCELLED', text:'Cancelled'},
    {key: 'EXPIRED', text:'Expired'},
];

export const dflt_ShoppingOrderStatusOptions:{[key:string]:{key:string, text:string}[]} = {
    en: en_ShoppingOrderStatusOptions,
    "zh-CN": zh_CN_ShoppingOrderStatusOptions
};



const zh_CN_LastNDaysOptions:{key:number, text:string}[]=[
    {key: -1, text:'任何日期'},
    {key: 7, text:'过去7天'},
    {key: 30, text:'过去30天'},
    {key: 182, text:'过去183天'},
    {key: 365, text:'过去365天'},
];
const en_LastNDaysOptions:{key:number, text:string}[]=[
    {key: -1, text:'Any Date'},
    {key: 7, text:'Last 7 Days'},
    {key: 30, text:'Last 40 Days'},
    {key: 182, text:'Last 183 Days'},
    {key: 365, text:'Last 365 Days'},
];
export const dflt_LastNDaysOptions: {[key:string]:{key:number, text:string}[]} = {
    en: en_LastNDaysOptions,
    "zh-CN": zh_CN_LastNDaysOptions
}

const zh_CN_CommissionStatusOptions:{key:string, text:string}[]=[
    {key:'', text:'任何状态'},
    {key: 'CREATED', text:'创建'},
    {key: 'PENDING', text:'等待结算'},
    {key: 'PAID', text:'已结算'},
    {key: 'CANCELLED', text:'取消'},
];
const en_CommissionStatusOptions:{key:string, text:string}[]=[
    {key:'', text:'Any State'},
    {key: 'CREATED', text:'Created'},
    {key: 'PENDING', text:'Pending'},
    {key: 'PAID', text:'Paid'},
    {key: 'CANCELLED', text:'Cancelled'},
];
export const dflt_CommissionStatusOptions: {[key:string]:{key:string, text:string}[]} = {
    en: en_CommissionStatusOptions,
    "zh-CN": zh_CN_CommissionStatusOptions
}

const zh_CN_ShippingRecordStatusOptions:{key:string, text:string}[]=[
    {key:'', text:'任何状态'},
    {key: 'Created', text:'创建'},
    {key: 'Delivered', text:'已签收'},
    {key: 'Voided', text:'无效'},
];
const en_ShippingRecordStatusOptions:{key:string, text:string}[]=[
    {key:'', text:'Any State'},
    {key: 'Created', text:'Created'},
    {key: 'Delivered', text:'Delivered'},
    {key: 'Voided', text:'Cancelled'},
];
export const dflt_ShippingRecordStatusOptions: {[key:string]: {key:string, text:string}[] } = {
    en: en_ShippingRecordStatusOptions,
    "zh-CN": zh_CN_ShippingRecordStatusOptions
}


const zh_CN_LicenceCategoryOptions:{key:string, text:string}[]=[
    {key: 'CPN L1', text:'CPN L1'},
    {key: 'CPN L2', text:'CPN L2'},
    {key: 'CPN L3', text:'CPN L3'},
    {key: 'CCS N1', text:'CCS N1'},
    {key: 'CCS N2', text:'CCS N2'},
    {key: 'CCS N3', text:'CCS N3'},
];
const en_LicenceCategoryOptions:{key:string, text:string}[]=[
    {key: 'CPN L1', text:'CPN L1'},
    {key: 'CPN L2', text:'CPN L2'},
    {key: 'CPN L3', text:'CPN L3'},
    {key: 'CCS N1', text:'CCS N1'},
    {key: 'CCS N2', text:'CCS N2'},
    {key: 'CCS N3', text:'CCS N3'},
];
export const dflt_LicenceCategoryOptions: {[key:string]:{key:string, text:string}[]} = {
    en: en_LicenceCategoryOptions,
    "zh-CN": zh_CN_LicenceCategoryOptions
}

